import {getMockupsCustomers} from "../../thunk";

const getID = (id) => {
    return `a${id}a`
}

export default {
    [getMockupsCustomers.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [getMockupsCustomers.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        state.data = action.payload.result;
        state.queryParams = {...action.meta.arg, page: +action.payload.page, limit: +action.payload.perPage, total: +action.payload.totalCount};
    },
    [getMockupsCustomers.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    }
}
